import React from 'react'

import withSlidableJobPopulation from '../HOCs/withSlidableJobList'

import JobBlock from './../jobBlock'
import DataSource from './dataSource'

const UrgentJobs = withSlidableJobPopulation(
    JobBlock,
    (props) => DataSource(props.languageCode, props.body),
    false,
    'section-featured-jobs',
	'top_recommend view_job_item'

)

export default UrgentJobs
